import { create } from 'zustand';

export const useUpdateStore = create((set) => ({
  pendingUpdate: null,
  updateStatus: 'idle', // 'idle' | 'no-update' | 'check-failed' | 'downloading' | 'installed' | 'restart-required' | 'error'
  downloadProgress: null,
  errorMessage: null,

  setPendingUpdate: (update) =>
    set({ pendingUpdate: update, updateStatus: 'idle', errorMessage: null }),
  clearPendingUpdate: () =>
    set({ pendingUpdate: null, updateStatus: 'idle', downloadProgress: null, errorMessage: null }),
  setUpdateStatus: (status) => set({ updateStatus: status }),
  setDownloadProgress: (progress) => set({ downloadProgress: progress }),
  setErrorMessage: (msg) => set({ errorMessage: msg, updateStatus: 'error' }),
}));
